import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const CalendarLegend: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="CalendarLegend">
      <div className="CalendarLegend__Title">{t('pages.calendar.legend.title')}</div>
      <ul>
        <li>
          <div className="CalendarLegendItem CalendarLegendItem--circle CalendarLegendItem--circle__success" />
          {t('pages.calendar.legend.success')}
        </li>
        <li>
          <div className="CalendarLegendItem CalendarLegendItem--circle CalendarLegendItem--circle__failed" />
          {t('pages.calendar.legend.failed')}
        </li>
        <li>
          <div className="CalendarLegendItem CalendarLegendItem--circle" />
          {t('pages.calendar.legend.registered')}
        </li>
        <li>
          <div className="CalendarLegendItem CalendarLegendItem__not_registered">
            <i className="icon icon-streak" />
          </div>
          {t('pages.calendar.legend.not_registered')}
        </li>
      </ul>
    </div>
  );
};

export default CalendarLegend;
